import { z } from 'zod';
/** Агенты и MCP (фаза 7.3, ADR-016). */
export const TOKEN_SCOPES = ['read', 'write', 'links'];
/** Токен: префикс, по которому его узнают сканеры утечек и люди, + 32 символа base62. */
export const TOKEN_PREFIX = 'sk_live_';
const scopes = z
    .array(z.enum(TOKEN_SCOPES))
    .max(3)
    .transform((s) => [...new Set(s)]);
export const createTokenSchema = z.object({
    name: z.string().trim().min(1).max(80).default('Агент'),
    scopes: scopes.default(['read', 'links']),
    /** Без срока — бессрочный (до отзыва). */
    expiresInDays: z.number().int().min(1).max(365).optional(),
});
export const patchTokenSchema = z
    .object({ name: z.string().trim().min(1).max(80), scopes })
    .partial()
    .refine((p) => Object.keys(p).length > 0, 'Нечего менять');
/** Сколько внешних MCP-серверов можно подключить (до тарифов фазы 9 — одно число для всех). */
export const MCP_SERVERS_MAX = 10;
export const createMcpServerSchema = z.object({
    name: z.string().trim().min(1).max(60),
    url: z.url({ protocol: /^https?$/ }).max(500),
    transport: z.enum(['http', 'sse']).default('http'),
    /** Токен доступа к серверу (Bearer) — хранится зашифрованным. */
    token: z.string().max(2000).optional(),
});
export const patchMcpServerSchema = z
    .object({ name: z.string().trim().min(1).max(60), enabled: z.boolean() })
    .partial()
    .refine((p) => Object.keys(p).length > 0, 'Нечего менять');
//# sourceMappingURL=agent.js.map